import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ContactWidgetComponent} from './components/contact-widget.component';
import {ContactService} from './services/contact.service';
import {BDSharedModule} from '@brother-apps/brother-dealerapp-shared-lib';
import {RouterLink} from '@angular/router';


@NgModule({
    imports: [
        CommonModule,
        BDSharedModule,
        RouterLink
    ],
    declarations: [
        ContactWidgetComponent
    ],
    exports:[
        ContactWidgetComponent
    ],
    providers: [
        ContactService
    ]

})
export class ContactWidgetModule {
}
